<template>
  <transition name="modal">
    <div
      class="modal-mask"
      data-test="graphics-trackingLinkWarning"
    >
      <div class="modal-container modal-container--confirm">
        <button
          class="modal-close"
          data-test="graphics-trackingLinkWarning-close"
          @click="$emit('close')"
        >
          <span class="fal fa-times" />
        </button>

        <div class="modal-header padding-sm">
          QR code missing a tracking link
        </div>

        <div class="modal-body">
          <p>
            This graphic contains
            {{ elementCount === 1 ? 'a QR code' : `${elementCount} QR codes` }}
            without a tracking link selected. Scans of
            {{ elementCount === 1 ? 'this QR code' : 'these QR codes' }}
            won't be tracked.
          </p>
          <p>
            Select the QR code layer to choose a tracking link, or save anyway
            to ignore this warning.
          </p>
        </div>

        <div class="modal-footer">
          <button
            class="btn btn-style-c btn-lg"
            data-test="graphics-trackingLinkWarning-save"
            @click="$emit('save')"
          >
            Save anyway
          </button>

          <button
            class="btn btn-style-a btn-lg"
            data-test="graphics-trackingLinkWarning-select"
            @click="$emit('select')"
          >
            Add tracking link
          </button>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'MissingTrackingLinkModal',

  props: {
    elementCount: {
      type: Number,
      default: 1,
    },
  },

  emits: ['close', 'save', 'select'],
};
</script>

<style lang="scss" scoped>
.modal-footer {
  display: flex;
  justify-content: flex-end;
  align-items: center;
}
</style>
